import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router'
import { get_portfolio_category_by_path, get_portfolio_category_items } from '../../services'
import { PortfolioItemGrid } from './PortfolioItems'
import { PgLayoutGrid } from '../PageLayout'
import PortfolioModal from './PortfolioModal'
import '../common.css'
import './portfolio_categories.css'
import './portfolio_categories_desktop.css'
import '../pagelayout.css'
import '../pagelayout_desktop.css'

export function PortfolioCategoryPreview({ category }) {
    return (
        <div className="category-preview">
            <a href={`portfolio/${category.path}`} className="category-preview-container">
                <img className="category-preview-img" src={category.thumbnail} alt={category.title} />
                <div className="category-preview-overlay"><h4>{category.title}</h4></div>
            </a>
        </div>
    )
}

export function categoryViewMapper(category_list) {
    return category_list.map(category => <PortfolioCategoryPreview category={category} />)
}

export function PortfolioCategoryGrid({ categories }) {
    return (<PgLayoutGrid>
        {categoryViewMapper(categories)}
    </PgLayoutGrid>
    )
}

export default function PortfolioCategory({ }) {

    const { category_path } = useParams()
    const [category, setCategory] = useState({ title: "placeholder", id: -1, items: [], path: 'placeholder' })
    const [selectedItem, setSelectedItem] = useState({})

    const handleItemClick = (item) => setSelectedItem(item)

    const handleModalDismiss = () => setSelectedItem({})

    async function getData(path) {
        const category_resp = await get_portfolio_category_by_path(path)
        console.log(category_resp)
        const items_resp = await get_portfolio_category_items(category_resp.data.items)
        const items = items_resp.data
        const data = { ...category_resp.data, items: items }
        console.log(data)
        setCategory(data)
    }

    useEffect(() => {
        getData(category_path)
    }, [category_path])

    return (
        <div className="main-content">
            <h1>{category.title}</h1>
            <PortfolioItemGrid items={category.items} handleSelect={handleItemClick} />
            {(selectedItem && selectedItem.photos) && <PortfolioModal photo_url={selectedItem.photos[0]} description={"portfolio item"} delegateClose={handleModalDismiss} />
            }
        </div>
    )
}
